export const getRollFromInput = (values: Record<string, unknown>): string => {
    const rollParts = Object.keys(values)
        .filter((key) => key.includes("roll_part"))
        .reduce((cur, key) => { return Object.assign(cur, { [key]: values[key] }) }, {});

    let rollNumber = "";
    Object.keys(rollParts).forEach(
        (value) => {
            rollNumber += values[value];
        }
    );

    return rollNumber;
}